import * as React from "react";
const SvgWalletAlt = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.1538 6.04205H3.84615C2.82655 6.04205 2 6.85976 2 7.86844V15.174C2 16.1827 2.82655 17.0004 3.84615 17.0004H16.1538C17.1734 17.0004 18 16.1827 18 15.174V7.86844C18 6.85976 17.1734 6.04205 16.1538 6.04205Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.9754 6.04337V4.90188C15.9753 4.62191 15.9127 4.34541 15.7922 4.09211C15.6717 3.83881 15.4961 3.61496 15.278 3.43651C15.06 3.25807 14.8048 3.12944 14.5307 3.0598C14.2566 2.99016 13.9703 2.98122 13.6923 3.03363L3.56308 4.74397C3.1232 4.8269 2.72637 5.05909 2.44102 5.4005C2.15567 5.7419 1.9997 6.17112 2 6.61412V8.47856",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.3064 12.7399C14.063 12.7399 13.825 12.6685 13.6226 12.5347C13.4202 12.4009 13.2624 12.2107 13.1693 11.9882C13.0761 11.7657 13.0518 11.5209 13.0993 11.2847C13.1467 11.0486 13.264 10.8316 13.4361 10.6613C13.6082 10.491 13.8275 10.3751 14.0663 10.3281C14.305 10.2811 14.5525 10.3052 14.7774 10.3974C15.0023 10.4895 15.1945 10.6456 15.3297 10.8458C15.465 11.0461 15.5371 11.2815 15.5371 11.5223C15.5371 11.8452 15.4075 12.1549 15.1767 12.3832C14.9458 12.6116 14.6328 12.7399 14.3064 12.7399Z",
      fill: "currentColor"
    }
  )
);
export default SvgWalletAlt;
